<template lang="pug">
  .page__items(:class="{'page__items--404': pages.page404Active}")
    .page__item(data-id="main")
      Main(v-on:load="test()" :class="{'component-none': !pages.mainPageActive}")
    .page__item(data-id="about")
      About(:class="{'component-none': !pages.aboutPageActive}")
    .page__item(data-id="events")
      Events(:class="{'component-none': !pages.eventsPageActive}")
    .page__item(data-id="menu")
      Menu(:class="{'component-none': !pages.menuPageActive}")
    .page__item(data-id="guests")
      Guests(:class="{'component-none': !pages.guestsPageActive}")
    .page__item(data-id="actions")
      Actions(:class="{'component-none': !pages.actionsPageActive}")
    .page__item(data-id="gallery")
      Gallery(:class="{'component-none': !pages.galleryPageActive}")
    .page__item(data-id="gallery-inside")
      GalleryInside(:class="{'component-none': !pages.galleryPageActive}")
    .page__item(data-id="contacts")
      Contacts(:class="{'component-none': !pages.contactsPageActive}")
    .page__item(data-id="page404")
      Page404(:class="{'component-none': !pages.page404Active}")

</template>

<script>
  import EventBus from '@/eventBus';


  import Main from '@/views/Main';
  import About from '@/views/About';
  import Events from '@/views/Events';
  import Menu from '@/views/Menu';
  import Guests from '@/views/Guests';
  import Actions from '@/views/Actions';
  import Gallery from '@/views/Gallery';
  import GalleryInside from '@/views/GalleryInside';
  import Contacts from '@/views/Contacts';
  import Page404 from '@/views/Page404';

  export default {
    data() {
      return {
          pages: {
              firstMainLoad: false,
              mainPageActive: false,
              aboutPageActive: false,
              eventsPageActive: false,
              menuPageActive: false,
              guestsPageActive: false,
              actionsPageActive: false,
              galleryPageActive: false,
              contactsPageActive: false,
              page404Active: false,
          },
      }
    },
    components: {
      Main,
      About,
      Events,
      Menu,
      Guests,
      Actions,
      Gallery,
      GalleryInside,
      Contacts,
      Page404
    },

    created() {
        EventBus.$on('pageDone', () => {
            if(this.firstMainLoad === true) {
                this.firstMainLoad = false;
                $('.main__content').css('opacity', '1');
                setTimeout(() => {
                    // $('.header').css('transform', 'translateY(0)');
                    // $('.main__slider').css('transform', 'translateY(0)');
                    $('.main__left').css('transform', 'translateX(0)');
                    $('.main__right').css('transform', 'translateX(0)');
                }, 500);
            }
        });
    },

    // Первый заход на страницу
    beforeRouteEnter(to, from, next) {
      next(vm => {
        // экземпляр компонента доступен как `vm`
        let event = vm.getEvent(to, true);
        let url = to.path || '';
        //console.log(event);
        EventBus.$emit(event, url);
        vm.firstMainLoad = true;
        EventBus.$emit('firstLoad', url);
      })
    },

    // Навигация по ссылкам
    beforeRouteUpdate(to, from, next) {
      this.getEvent(from, false);
      let event = this.getEvent(to, true);
      let url = to.path || '';
      if (from.path === '/') {
          $('.main__content-left-logo-img').addClass('main__content-left-logo-img--move');
          setTimeout(() => {
              EventBus.$emit('routeUpdate', url);
              EventBus.$emit(event, url);
              next();
          }, 500);
          setTimeout(() => {
              EventBus.$emit(event, url);
              next();
          }, 1000);
      } else if (to.path === '/') {
          EventBus.$emit('routeUpdate', url);
          EventBus.$emit(event, url);
          $('.main__content-left-logo-img').removeClass('main__content-left-logo-img--move');
          next();
      } else {
          EventBus.$emit(event, url);
          next();
      }
    },

    methods: {
      getEvent(route, value) {
        let routeName = route.name || '';
        let path  = route.path;
        let event = '';

        if(path === '/') {
          event = 'loadMainPage';
          this.pages.mainPageActive = value;
        }
        else if(path === '/o-nas') {
          event = 'loadAboutPage';
            this.pages.aboutPageActive = value;
        }
        else if(path === '/sobytiya') {
          event = 'loadEventsPage';
            this.pages.eventsPageActive = value;
        }
        else if(path === '/menyu') {
          event = 'loadMenuPage';
            this.pages.menuPageActive = value;
        }
        else if(path === '/gosti') {
          event = 'loadGuestsPage';
            this.pages.guestsPageActive = value;
        }
        else if(path === '/akcii') {
          event = 'loadActionsPage';
            this.pages.actionsPageActive = value;
        }
        else if(path === '/galereya') {
          event = 'loadGalleryPage';
            this.pages.galleryPageActive = value;
        }
        else if(path === '/kontakty') {
          event = 'loadContactsPage';
          this.pages.contactsPageActive = value;
        }
        else {
          event = 'load404Page';
          this.pages.page404Active = value;
        }

        if(routeName === 'GalleryInside') {
          event = 'loadGalleryInsidePage';
          this.pages.galleryPageActive = value;
        }

        return event;
      }
    }
  }
</script>
